export default __webpack_public_path__ + "fbf93c9be38a5ee07b4fdd3786008a94.woff2";